import React from 'react'

import {Box} from "@mui/material"
import {IconSeeker} from "@ui-seeker/core"


export default function exportedColumn() {

    return [{
        name: "exported",
        label: "Export Status",
        options: {
            filterType: 'checkbox',
            display: 'excluded',
            customBodyRowRender: value => value ? "Exported" : "Not Exported",
        }
    }, {
        name: 'exported',
        label: 'Exported',
        options: {
            filter: false,
            customBodyRowRenderLite: value => <Box
                sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <IconSeeker icon={value ? 'square-check' : 'square-xmark'}
                            sx={{color: `colors.${value ? 'green' : 'red'}`, fontSize: '1.5rem'}}/>
            </Box>,
        }
    }]
}